import React from 'react';
import { Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField';
import {connect} from 'react-redux';
import {AddMenuEpic} from '../../actions/website.actions';
import {LoadWebsiteDetailsEpic, SaveWebsiteContentEpic } from '../../actions/website.actions';

class AddMenu extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        menu_name: '',
        menu_groups: [{id:Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), menu_items:[], disabled:false, group_note:'', group_description:'', group_name:''}],
        menu_duration_time_end: null,
        menu_duration_time_start: null,
        menu_duration_name: null,
        disabled: false,
        language: 'en-US',
        currency_symbol: '$',
        menu_note: '',
        menu_description: '',
        menu_url: '',
        id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      };
      this.Field = this.Field.bind(this);
    }

    componentDidMount(){
      this.props.loadWebsiteDetails(this.props.companyId);
    }

    componentWillReceiveProps(nextProps) {
      
    }

    Field({propName, label, ...props}){
      return (
        <TextField {...props}
          floatingLabelText={label} 
          value={this.state[propName]} 
          onChange={(e)=> this.setState({[propName]: e.target.value})}
          errorText={this.state[`${propName}ValidationError`]}
        />
      );
    }

    render() {
      
      return (<Card> 
            <CardHeader
              title="Add a Menu"
            />
            <CardText>
              <this.Field propName="menu_name" label="Menu Name*" fullWidth={true}/><br/>
              <this.Field propName="currency_symbol" label="Currency Symbol*" fullWidth={true}/><br/>
              <this.Field propName="language" label="Language*" fullWidth={true}/><br/>
              <this.Field propName="menu_note" label="Menu Note" fullWidth={true}/><br/>
              <this.Field propName="menu_description" label="Menu Description" fullWidth={true}/><br/>
            </CardText>
            <CardActions>
              <RaisedButton primary={true} label="Add" onClick={() => {
                  this.props.addMenu(this.props.website._id, this.state)
                }
              } />
            </CardActions>
        </Card>
      );
    }
}

let mapStateToProps = ({websiteEndpoint, authEndpoint, nav},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false,
  website: websiteEndpoint.website,
  companyId: nav.selectedCompany ? nav.selectedCompany : authEndpoint.companyId
})

let mapDispatchToProps = (dispatch) => ({
  loadWebsiteDetails : (companyId) => dispatch(LoadWebsiteDetailsEpic(companyId)),
  save : (id, data) => dispatch(SaveWebsiteContentEpic(id, data)),
  addMenu: (websiteId, menuData) => dispatch(AddMenuEpic(websiteId, menuData))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMenu);


// WEBPACK FOOTER //
// ./src/containers/Menu/AddMenu.js